import * as React from 'react'
import { Checkbox as MuiCheckbox, CheckboxProps } from '@mui/material'
import { styled, useTheme } from '../../theme/styled'
import { CheckboxIcon } from '../icons/CheckboxIcon'

const CustomCheckbox = styled(MuiCheckbox)`
  padding: 0;
`

const Checkbox = (props: CheckboxProps) => {
  const theme = useTheme()
  return (
    <CustomCheckbox
      {...props}
      checkedIcon={<CheckboxIcon color={theme.av8.primaryColor} backgroundColor='transparent' />}
      icon={<CheckboxIcon color='transparent' backgroundColor='transparent' />}
    />
  )
}

export default Checkbox
